import { render } from "./SendEmailModal.vue?vue&type=template&id=4a89e700"
import script from "./SendEmailModal.vue?vue&type=script&lang=js"
export * from "./SendEmailModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__